import React from "react";
import { UserInfo } from "./UserInfo";

export const GeneralSettings: React.FC = () => (
    <div className="settings__general">
        <header className="settings__header">
            <h3>Profile</h3>
        </header>

        <UserInfo />
    </div>
);
